import { app } from '../initApp';
import { UseCase } from './usecase/UseCase';

interface CustomMsgPopupUseCaseOptions {
  title?: React.ReactNode;
  url?: string;
  onClick?: Function;
  onCancelClick?: Function;
  showCancel?: boolean;
  showConfirm?: boolean;
  showCancelMsg?: string;
  showConfirmMsg?: string;
  isConfirmOutline?: boolean;
  isCancelOutline?: boolean;
  disableConfirmBtn?: boolean;
  disableCancelBtn?: boolean;
  cancelBtnIcon?: string;
  confirmBtnIcon?: string;
}

export const customMsgPopupUseCase: UseCase = {
  type: 'SHOW_CUSTOM_MSG_POPUP',

  run: (options: CustomMsgPopupUseCaseOptions) => {
    return Cx.resolve(options);
  }
};

export function showCustomMsgPopup(options: CustomMsgPopupUseCaseOptions) {
  app.runUseCase(customMsgPopupUseCase, options);
}